import React, { useEffect, useState } from 'react';
import { Cookie, X } from 'lucide-react';

const SESSION_KEY = 'cookie-banner-dismissed-v1';

export const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const dismissed = sessionStorage.getItem(SESSION_KEY);
      if (!dismissed) {
        // small delay so it doesn't jump in on first paint
        const t = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="הודעת עוגיות"
      dir="rtl"
      className="fixed bottom-5 right-5 z-[9997] w-[min(380px,calc(100vw-2.5rem))] animate-in fade-in slide-in-from-bottom-4 duration-500"
    >
      <div className="relative bg-[#EAE6D7] text-[#412018] border border-[#412018]/15 rounded-xl shadow-2xl p-5 pe-6">
        <button
          type="button"
          onClick={dismiss}
          aria-label="סגור הודעת עוגיות"
          className="absolute top-2 start-2 p-1.5 rounded-full text-[#412018]/60 hover:text-[#412018] hover:bg-[#412018]/5 focus:outline-none focus:ring-2 focus:ring-[#67392b]/40 transition-colors"
        >
          <X size={16} aria-hidden="true" />
        </button>

        <div className="flex items-start gap-3">
          <div className="shrink-0 w-10 h-10 rounded-full bg-[#67392b]/10 flex items-center justify-center text-[#67392b]">
            <Cookie size={20} aria-hidden="true" />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-sm font-bold mb-1 leading-tight">אנו משתמשים בעוגיות</h2>
            <p className="text-xs leading-relaxed text-[#412018]/80 m-0">
              האתר שלנו משתמש בעוגיות לשיפור חוויית הגלישה, אנליטיקה והתאמת תוכן. המשך הגלישה
              מהווה הסכמה למדיניות שלנו.
            </p>
            <div className="flex flex-wrap items-center gap-2 mt-3">
              <button
                type="button"
                onClick={dismiss}
                className="px-4 py-1.5 text-xs font-semibold bg-[#67392b] text-[#EAE6D7] rounded-full hover:bg-[#412018] focus:outline-none focus:ring-2 focus:ring-[#67392b]/40 transition-colors"
              >
                אישור
              </button>
              <a
                href="/policies/privacy-policy"
                className="px-3 py-1.5 text-xs font-medium text-[#67392b] hover:text-[#412018] underline underline-offset-2 focus:outline-none focus:ring-2 focus:ring-[#67392b]/40 rounded transition-colors"
              >
                מדיניות פרטיות
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
